import React from "react";
import { motion } from "framer-motion";
import styles from "./Dokgenai.module.scss";

// --- Centralized Icons ---
const Icons = {
  Refresh: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125"
      ></path>
    </svg>
  ),
  Code: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a2.25 2.25 0 01.9-1.872l7.906-3.839A2.25 2.25 0 0118.105 3H5.895a2.25 2.25 0 00-2.03 2.018L3.75 14.25m0 0a2.25 2.25 0 002.25 2.25h13.5a2.25 2.25 0 002.25-2.25m-16.5-3V9.75m16.5 3v2.25m0 0V9.75m0 2.25h-3"
      ></path>
    </svg>
  ),
  Layers: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25a1.125 1.125 0 011.125-1.125h.75m7.5 10.375v3.375c0 .621-.504 1.125-1.125 1.125H18.75M4.5 7.5v9a1.125 1.125 0 001.125 1.125H15M12 2.25v9m0 0l3-3m-3 3l-3-3"
      ></path>
    </svg>
  ),
  Sign: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
      ></path>
    </svg>
  ),
  Analyze: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 5.25l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
      ></path>
    </svg>
  ),
  Builder: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625a2.25 2.25 0 00-2.25 2.25v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
      ></path>
    </svg>
  ),
  CheckCircle: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
      ></path>
    </svg>
  ),
  Extract: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
      ></path>
    </svg>
  ),
  ArrowDown: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 14l-7 7m0 0l-7-7m7 7V3"
      ></path>
    </svg>
  ),
  ArrowRight: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 5l7 7m0 0l-7-7m7-7H3"
      ></path>
    </svg>
  ),
  CheckTick: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="3"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Bank: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <polygon points="12 2 2 7 22 7 12 2"></polygon>
      <polyline points="2 17 22 17"></polyline>
      <polyline points="2 22 22 22"></polyline>
      <line x1="6" y1="17" x2="6" y2="7"></line>
      <line x1="10" y1="17" x2="10" y2="7"></line>
      <line x1="14" y1="17" x2="14" y2="7"></line>
      <line x1="18" y1="17" x2="18" y2="7"></line>
    </svg>
  ),
  Clipboard: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    </svg>
  ),
  TrendingUp: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  Server: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
      <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
      <line x1="6" y1="6" x2="6.01" y2="6"></line>
      <line x1="6" y1="18" x2="6.01" y2="18"></line>
    </svg>
  ),
  Shield: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  CreditCard: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  ),
  Cloud: () => (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="currentColor"
      width="1em"
      height="1em"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom New Hero Art: Animated Document Generation ---
const DokGenHeroArt = () => (
  <div className={styles["dokgen-hero-art"]} aria-hidden>
    <svg
      className={styles["dokgen-hero-svg"]}
      viewBox="0 0 400 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="dg-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background connection lines */}
      <path
        d="M80 150 L140 150 M320 120 L260 120 M300 240 L260 240"
        stroke="rgba(99, 102, 241, 0.3)"
        strokeWidth="2"
        strokeDasharray="4 4"
        className={styles["dokgen-anim-dash"]}
      />

      {/* JSON/API Nodes floating around */}
      <rect
        x="30"
        y="130"
        width="50"
        height="40"
        rx="6"
        fill="rgba(14, 165, 233, 0.1)"
        stroke="#0ea5e9"
        strokeWidth="1.5"
        className={styles["dokgen-float-node1"]}
      />
      <text
        x="40"
        y="153"
        fill="#0ea5e9"
        fontSize="12"
        fontFamily="monospace"
        fontWeight="bold"
      >
        JSON
      </text>

      <rect
        x="320"
        y="100"
        width="50"
        height="40"
        rx="6"
        fill="rgba(79, 70, 229, 0.1)"
        stroke="#4f46e5"
        strokeWidth="1.5"
        className={styles["dokgen-float-node2"]}
      />
      <text
        x="330"
        y="123"
        fill="#4f46e5"
        fontSize="12"
        fontFamily="monospace"
        fontWeight="bold"
      >
        API
      </text>

      <rect
        x="300"
        y="220"
        width="60"
        height="40"
        rx="6"
        fill="rgba(16, 185, 129, 0.1)"
        stroke="#10b981"
        strokeWidth="1.5"
        className={styles["dokgen-float-node3"]}
      />
      <text
        x="310"
        y="243"
        fill="#10b981"
        fontSize="12"
        fontFamily="monospace"
        fontWeight="bold"
      >
        Sign
      </text>

      {/* Central Document Base */}
      <rect
        x="140"
        y="50"
        width="120"
        height="200"
        rx="8"
        fill="rgba(255,255,255,0.03)"
        stroke="rgba(255,255,255,0.2)"
        strokeWidth="2"
      />

      {/* Document Text Lines */}
      <line
        x1="160"
        y1="80"
        x2="240"
        y2="80"
        stroke="#94a3b8"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="160"
        y1="100"
        x2="220"
        y2="100"
        stroke="#94a3b8"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="160"
        y1="120"
        x2="240"
        y2="120"
        stroke="#94a3b8"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="160"
        y1="140"
        x2="200"
        y2="140"
        stroke="#94a3b8"
        strokeWidth="4"
        strokeLinecap="round"
      />

      {/* Signature Animation */}
      <path
        d="M170 210 C 180 190, 190 220, 200 205 S 220 220, 230 200"
        stroke="#38bdf8"
        strokeWidth="2"
        fill="none"
        className={styles["dokgen-anim-sign"]}
      />

      {/* Glowing Scanner Line */}
      <line
        x1="120"
        y1="50"
        x2="280"
        y2="50"
        stroke="#0ea5e9"
        strokeWidth="3"
        filter="url(#dg-glow)"
        className={styles["dokgen-anim-scanner"]}
      />
    </svg>
  </div>
);

const Dokgenai = () => {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION (REDESIGNED) */}
        <section className={styles["dokgen-hero"]}>
          <div className={styles["dokgen-hero-mesh"]} />
          <div className={styles["dokgen-hero-glow-1"]} />
          <div className={styles["dokgen-hero-glow-2"]} />

          <div className="sec-container">
            <div className={styles["dokgen-hero-row"]}>
              <motion.div
                className={styles["dokgen-hero-inner"]}
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> Document Intelligence
                  Platform
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  <span className="product-text-gradient">AI-Powered</span>{" "}
                  Document Intelligence Platform
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Generate, edit, sign, and analyze enterprise documents
                  directly from your systems using an API-first platform.
                </motion.p>
                <motion.p className="product-sublead" variants={childVariants}>
                  DokGen.ai combines document automation, digital signatures,
                  and AI-powered insights to streamline document workflows for
                  modern organizations.
                </motion.p>
                <motion.div className={styles["dokgen-pills"]} variants={childVariants}>
                  <span className={styles["dokgen-pill"]}>AI Powered</span>
                  <span className={styles["dokgen-pill"]}>API First Platform</span>
                  <span className={styles["dokgen-pill"]}>Enterprise Ready</span>
                </motion.div>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                  >
                    Book a Demo
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                  >
                    Enter Developer Sandbox
                  </a> */}
                </motion.div>
                <motion.p className={styles["dokgen-hero-foot"]} variants={childVariants}>
                  No credit card required · Free sandbox access
                </motion.p>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <DokGenHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. WHY DIFFERENT (Hover Effect: 3D Tilt) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Why DokGen.ai is Different</h2>
              <p className="gen-h2-sub">
                Most document generation tools require regenerating documents
                for every change.
              </p>
              <p className="gen-h2-sub" style={{ marginTop: "1.2rem" }}>
                DokGen.ai enables real-time document editing through a secure
                SSO-enabled editor. Users can fix small errors instantly without
                restarting the process.
              </p>
            </motion.div>
            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-tilt"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ffedd5",
                    color: "#ea580c",
                    borderColor: "#ffedd5",
                  }}
                >
                  <Icons.Refresh />
                </div>
                <h3 className="product-card-title">
                  Real-Time Editing Without Regeneration
                </h3>
                <p className="product-card-desc">
                  Edit generated documents instantly without restarting
                  workflows.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-tilt"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Code />
                </div>
                <h3 className="product-card-title">
                  API-First Document Platform
                </h3>
                <p className="product-card-desc">
                  Generate documents directly from system data using simple
                  APIs.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-tilt"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dbeafe",
                    color: "#2563eb",
                    borderColor: "#dbeafe",
                  }}
                >
                  <Icons.Layers />
                </div>
                <h3 className="product-card-title">
                  Built for High-Volume Document Workflows
                </h3>
                <p className="product-card-desc">
                  Handle thousands of documents per hour with automated
                  processing.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 3. TRUST & PARTNERS STRIP */}
        <section
          className="product-section product-section-alt"
          style={{ padding: "6.4rem 0" }}
        >
          <div className="sec-container">
            <p className="product-strip-label">
              Trusted by modern enterprises & Partner ecosystem
            </p>
            <div className="product-partner-strip">
              <div className="product-partner-box">Salesforce</div>
              <div className="product-partner-box">HubSpot</div>
              <div className="product-partner-box">Microsoft Dynamics</div>
              <div className="product-partner-box">Okta</div>
              <div className="product-partner-box">Microsoft Entra</div>
              <div className="product-partner-box">AWS</div>
              <div className="product-partner-box">Azure</div>
            </div>
          </div>
        </section>

        {/* 4. PLATFORM STATISTICS (Hover Effect: Soft Scale) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">10M+</p>
                <p className="product-stat-label">Documents Generated</p>
              </motion.div>
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">1000+</p>
                <p className="product-stat-label">Templates Created</p>
              </motion.div>
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">500+</p>
                <p className="product-stat-label">Automated Workflows</p>
              </motion.div>
              <motion.div
                className="product-stat-card hover-scale"
                variants={childVariants}
              >
                <p className="product-stat-num">99.99%</p>
                <p className="product-stat-label">Platform Uptime</p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 5. PROBLEM SECTION (Hover Effect: Warning Wobble) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              style={{ textAlign: "left", marginLeft: 0 }}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">
                Manual document workflows hold you back
              </h2>
              <p className="gen-h2-sub">
                Organizations struggle with fragmented processes that slow down
                operations and introduce risk.
              </p>
            </motion.div>
            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div className="product-prob-num">1</div>
                <h3 className="product-prob-title">Manual templates</h3>
                <p className="product-card-desc">
                  Copy-paste workflows and version chaos across teams.
                </p>
              </motion.div>
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-prob-num"
                  style={{ background: "#fef3c7", color: "#d97706" }}
                >
                  2
                </div>
                <h3 className="product-prob-title">Slow regeneration cycles</h3>
                <p className="product-card-desc">
                  Every edit requires full document regeneration and review.
                </p>
              </motion.div>
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-prob-num"
                  style={{ background: "#ffedd5", color: "#ea580c" }}
                >
                  3
                </div>
                <h3 className="product-prob-title">Data inconsistencies</h3>
                <p className="product-card-desc">
                  Multiple sources of truth lead to errors and rework.
                </p>
              </motion.div>
              <motion.div
                className="product-card product-prob-card hover-wobble"
                variants={childVariants}
              >
                <div
                  className="product-prob-num"
                  style={{ background: "#ffe4e6", color: "#e11d48" }}
                >
                  4
                </div>
                <h3 className="product-prob-title">Compliance risks</h3>
                <p className="product-card-desc">
                  Audit trails and signing workflows are hard to enforce.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 6. SOLUTION SECTION */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-split"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div variants={childVariants}>
                <h2 className="gen-h2">One platform for document automation</h2>
                <p className="gen-h2-sub">
                  DokGen.ai is an enterprise document automation platform.
                  Documents are automatically generated from your system data
                  and templates—no manual assembly.
                </p>
                <ul className="product-checklist">
                  <li className="product-check-item">
                    <span className="product-check-icon">
                      <Icons.CheckTick />
                    </span>
                    <span>
                      <strong>JSON + template ID → PDF.</strong> Send structured
                      data and get enterprise-ready documents in seconds.
                    </span>
                  </li>
                  <li className="product-check-item">
                    <span className="product-check-icon">
                      <Icons.CheckTick />
                    </span>
                    <span>
                      Integrates with{" "}
                      <strong>CRMs, ERPs, and internal applications</strong> so
                      documents flow from your existing systems.
                    </span>
                  </li>
                  <li className="product-check-item">
                    <span className="product-check-icon">
                      <Icons.CheckTick />
                    </span>
                    <span>
                      <strong>Real-time editing</strong> of generated PDFs with
                      secure SSO—no need to regenerate for small corrections.
                    </span>
                  </li>
                </ul>
              </motion.div>
              <motion.div
                variants={childVariants}
                className="product-code-block"
              >
                <pre>
                  <span className="product-code-comment">
                    // Generate document from template
                  </span>
                  <br />
                  <br />
                  <span className="product-code-method">POST</span>{" "}
                  <span className="product-code-url">
                    /v1/documents/generate
                  </span>
                  <br />
                  {`{`}
                  <br />
                  <span className="product-code-key"> "template_id"</span>:{" "}
                  <span className="product-code-str">"contract-v2"</span>,<br />
                  <span className="product-code-key"> "data"</span>: {`{`}
                  <br />
                  <span className="product-code-key">
                    {" "}
                    "customer_name"
                  </span>: <span className="product-code-str">"Acme Corp"</span>
                  ,<br />
                  <span className="product-code-key">
                    {" "}
                    "effective_date"
                  </span>:{" "}
                  <span className="product-code-str">"2026-04-27"</span>,
                  <br />
                  <span className="product-code-key"> "terms"</span>:{" "}
                  {`{ ... }`}
                  <br />
                  {`  }`}
                  <br />
                  {`}`}
                  <br />
                  <br />
                  <span className="product-code-comment">
                    // → Returns PDF URL in &lt; 2s
                  </span>
                </pre>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 7. DOC INTEL PLATFORM (Hover Effect: Colored Glows) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Document Intelligence Platform</h2>
              <p className="gen-h2-sub">
                Generate, edit, sign, and analyze enterprise documents using
                automation and AI.
              </p>
            </motion.div>
            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Code />
                </div>
                <h3 className="product-card-title">Generate</h3>
                <p className="product-card-desc">
                  Automatically generate documents from CRM, ERP, and internal
                  system data.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ffedd5",
                    color: "#ea580c",
                    borderColor: "#ffedd5",
                  }}
                >
                  <Icons.Refresh />
                </div>
                <h3 className="product-card-title">Edit</h3>
                <p className="product-card-desc">
                  Instantly edit generated documents without restarting the
                  generation process.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ffedd5",
                    color: "#ea580c",
                    borderColor: "#ffedd5",
                  }}
                >
                  <Icons.Sign />
                </div>
                <h3 className="product-card-title">Sign</h3>
                <p className="product-card-desc">
                  Enable legally compliant digital signatures including Aadhaar
                  eSign and DSC.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-purple"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                  }}
                >
                  <Icons.Analyze />
                </div>
                <h3 className="product-card-title">Analyze</h3>
                <p className="product-card-desc">
                  Use AI to extract insights, validate document data, and
                  summarize complex reports.
                </p>
              </motion.div>
            </motion.div>

            {/* 8. AI POWERED (Hover Effect: Gentle Float) */}
            <motion.div
              className="product-section-head"
              style={{ marginTop: "12rem" }}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">AI-Powered Capabilities</h2>
              <p className="gen-h2-sub">
                Intelligent document capabilities powered by AI to accelerate
                and secure your workflows.
              </p>
            </motion.div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "2.4rem",
              }}
            >
              <motion.div
                className="product-card hover-float"
                style={{ padding: "2.4rem" }}
                variants={childVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                    width: "4rem",
                    height: "4rem",
                    fontSize: "2rem",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Builder />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  AI Template Builder
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Generate templates automatically by analyzing uploaded
                  documents.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-float"
                style={{ padding: "2.4rem" }}
                variants={childVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                    width: "4rem",
                    height: "4rem",
                    fontSize: "2rem",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.CheckCircle />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  AI Document Validation
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Detect missing fields, inconsistencies, and data errors.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-float"
                style={{ padding: "2.4rem" }}
                variants={childVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                    width: "4rem",
                    height: "4rem",
                    fontSize: "2rem",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Builder />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  AI Summaries
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Automatically summarize complex reports and legal documents.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-float"
                style={{ padding: "2.4rem" }}
                variants={childVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                    width: "4rem",
                    height: "4rem",
                    fontSize: "2rem",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Extract />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  AI Data Extraction
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Extract structured data and map it to templates or workflows.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-float"
                style={{ padding: "2.4rem" }}
                variants={childVariants}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#f3e8ff",
                    color: "#9333ea",
                    borderColor: "#f3e8ff",
                    width: "4rem",
                    height: "4rem",
                    fontSize: "2rem",
                    marginBottom: "1.6rem",
                  }}
                >
                  <Icons.Analyze />
                </div>
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  AI Insights
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Identify key information like loan amounts or financial
                  indicators.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* 9. DOCUMENT WORKFLOW */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Generate → Edit → Sign → Deliver</h2>
              <p className="gen-h2-sub">
                One seamless workflow from system data to signed, delivered
                documents.
              </p>
            </motion.div>
            <motion.div
              className="product-workflow"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">CRM / ERP Data</p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div
                className="product-wf-step product-wf-step--highlight"
                variants={childVariants}
              >
                <p className="product-wf-title">Generate Document</p>
                <p className="product-wf-sub">(DokGen Engine)</p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">Edit Document</p>
                <p className="product-wf-sub" style={{ color: "#64748b" }}>
                  (SSO Editor)
                </p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">Digital Signature</p>
                <p className="product-wf-sub" style={{ color: "#64748b" }}>
                  (Aadhaar eSign / DSC)
                </p>
              </motion.div>
              <div className="product-wf-arrow">
                <Icons.ArrowDown />
              </div>
              <motion.div className="product-wf-step" variants={childVariants}>
                <p className="product-wf-title">Deliver to Customer</p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 10. INDUSTRIES & USE CASES (Hover Effect: Elegant Lifts & Slide Ups) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Built for every industry</h2>
              <p className="gen-h2-sub">
                From banking to enterprise IT—document automation that fits your
                domain.
              </p>
            </motion.div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                gap: "1.6rem",
                marginBottom: "8rem",
              }}
            >
              {[
                {
                  name: "Banking",
                  icon: Icons.Bank,
                  hoverClass: "product-hover-lift",
                  color: "#3b82f6",
                  bg: "#eff6ff",
                },
                {
                  name: "NBFC",
                  icon: Icons.Clipboard,
                  hoverClass: "product-hover-industry-scale",
                  color: "#10b981",
                  bg: "#ecfdf5",
                },
                {
                  name: "Insurance",
                  icon: Icons.Shield,
                  hoverClass: "product-hover-industry-purple",
                  color: "#a855f7",
                  bg: "#faf5ff",
                },
                {
                  name: "Mutual Funds",
                  icon: Icons.TrendingUp,
                  hoverClass: "product-hover-industry-emerald",
                  color: "#059669",
                  bg: "#ecfdf5",
                },
                {
                  name: "Fintech",
                  icon: Icons.CreditCard,
                  hoverClass: "product-hover-tilt-left",
                  color: "#f59e0b",
                  bg: "#fffbeb",
                },
                {
                  name: "SaaS Platforms",
                  icon: Icons.Cloud,
                  hoverClass: "product-hover-tilt-right",
                  color: "#ec4899",
                  bg: "#fdf2f8",
                },
                {
                  name: "Enterprise IT",
                  icon: Icons.Server,
                  hoverClass: "product-hover-industry-rose",
                  color: "#e11d48",
                  bg: "#fff1f2",
                },
              ].map((ind) => {
                const Icon = ind.icon;
                return (
                  <div
                    key={ind.name}
                    className={`product-industry-card ${ind.hoverClass}`}
                  >
                    <div
                      className="product-industry-icon"
                      style={{ backgroundColor: ind.bg, color: ind.color }}
                    >
                      <Icon />
                    </div>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: 600,
                        fontSize: "1.5rem",
                        color: "#0f172a",
                      }}
                    >
                      {ind.name}
                    </p>
                  </div>
                );
              })}
            </div>

            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Document types we power</h2>
              <p className="gen-h2-sub">
                Loan agreements, CAMs, valuation reports, statements, and more.
              </p>
            </motion.div>

            <div className="product-grid-3">
              {[
                {
                  t: "Loan Agreements",
                  d: "Generate and sign loan documentation at scale",
                },
                {
                  t: "Credit Assessment Memos",
                  d: "Structured credit memos from system data",
                },
                {
                  t: "Valuation Reports",
                  d: "Property, asset, and business valuations",
                },
                {
                  t: "Field Investigation Reports",
                  d: "Standardized FIR templates with data merge",
                },
                {
                  t: "Account Statements",
                  d: "Periodic account and transaction statements",
                },
                {
                  t: "Portfolio Statements",
                  d: "Investment and holdings summaries",
                },
                { t: "Invoices", d: "Billing and tax-compliant invoices" },
                {
                  t: "Legal Opinion Reports",
                  d: "Structured legal opinions and memos",
                },
                {
                  t: "Marketing Brochures",
                  d: "Product and campaign collateral",
                },
              ].map((uc) => (
                <div
                  key={uc.t}
                  className="product-card hover-slide-up"
                  style={{ padding: "2.4rem" }}
                >
                  <h3
                    className="product-card-title"
                    style={{ fontSize: "1.6rem" }}
                  >
                    {uc.t}
                  </h3>
                  <p
                    className="product-card-desc"
                    style={{ fontSize: "1.4rem" }}
                  >
                    {uc.d}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 11. SECURITY & INTEGRATIONS (Hover Effect: Inset Press) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <h2 className="gen-h2">Enterprise-grade security & compliance</h2>
              <p className="gen-h2-sub">
                Integrates with your stack, protected by top-tier controls.
              </p>
            </motion.div>

            <div className="product-pill-row">
              {["GDPR", "DPDP", "SOC 2", "ISO 27001"].map((p) => (
                <div key={p} className="product-sec-pill">
                  {p}
                </div>
              ))}
            </div>

            <div className="product-grid-4">
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Encryption in transit
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  TLS 1.3 for all API and web traffic
                </p>
              </div>
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Encryption at rest
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  AES-256 for stored documents
                </p>
              </div>
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Role-based access control
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Fine-grained permissions and SSO
                </p>
              </div>
              <div
                className="product-card hover-inset"
                style={{ padding: "2.4rem" }}
              >
                <h3
                  className="product-card-title"
                  style={{ fontSize: "1.6rem" }}
                >
                  Audit logs
                </h3>
                <p className="product-card-desc" style={{ fontSize: "1.4rem" }}>
                  Full activity and access audit trails
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 12. DEVELOPER BLOCK */}
        <section
          className="product-section product-section-alt"
          style={{ paddingBottom: "0", borderBottom: "none" }}
        >
          <div className="sec-container">
            <div className="product-dev-block">
              <div className={styles["dokgen-hero-ambient"]} style={{ zIndex: 1 }} />
              <div className="product-dev-content">
                <div className="product-dev-text">
                  <h2 className="gen-h2" style={{ color: "#fff" }}>
                    Built for developers
                  </h2>
                  <p
                    className="gen-h2-sub"
                    style={{ color: "#cbd5e1", marginBottom: "3.2rem" }}
                  >
                    REST API, SDKs, and webhooks. Get from zero to first
                    document in minutes with our sandbox.
                  </p>
                  <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                    style={{
                      border: "none",
                      padding: 0,
                      justifyContent: "flex-start",
                      color: "#a5b4fc",
                      textDecoration: "underline",
                      marginBottom: "2.4rem",
                    }}
                  >
                    View API reference →
                  </a>
                  <br />
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-primary"
                  >
                    Enter Developer Sandbox
                  </a> */}
                </div>
                <div className="product-dev-code">
                  <p
                    style={{
                      color: "#94a3b8",
                      fontSize: "1.4rem",
                      fontFamily: "monospace",
                      marginBottom: "1.6rem",
                      fontWeight: "bold",
                    }}
                  >
                    POST /generate-document
                  </p>
                  <div
                    className="product-code-block"
                    style={{ background: "rgba(0,0,0,0.3)", boxShadow: "none" }}
                  >
                    <p
                      style={{
                        color: "#a5b4fc",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        marginBottom: "0.8rem",
                      }}
                    >
                      Input
                    </p>
                    <pre style={{ marginBottom: "2.4rem" }}>
                      {`{`}
                      <br />
                      <span className="product-code-key">
                        {" "}
                        template_id
                      </span>:{" "}
                      <span className="product-code-str">
                        "valuation_report"
                      </span>
                      ,<br />
                      <span className="product-code-key"> data</span>:{" "}
                      {`{ ... }`}
                      <br />
                      {`}`}
                    </pre>
                    <p
                      style={{
                        color: "#a5b4fc",
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        marginBottom: "0.8rem",
                      }}
                    >
                      Output
                    </p>
                    <p
                      style={{
                        color: "#f8fafc",
                        margin: 0,
                        fontFamily: "sans-serif",
                      }}
                    >
                      Generated PDF
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 13. COMPARISON SECTION */}
        <section className="product-section">
          <div className="sec-container">
            <div className="product-section-head">
              <h2 className="gen-h2">Compare with leading platforms</h2>
              <p className="gen-h2-sub">
                See how DokGen.ai’s API-first platform stacks up.
              </p>
            </div>
            <div className="product-table-wrapper">
              <table className="product-table">
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th className="highlight-col">DokGen.ai</th>
                    <th>DocuSign</th>
                    <th>Conga</th>
                    <th>Nintex</th>
                    <th>PandaDoc</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    [
                      "API-first architecture",
                      "✓",
                      "Limited",
                      "Limited",
                      "Limited",
                      "Limited",
                    ],
                    [
                      "JSON-based document generation",
                      "✓",
                      "—",
                      "Partial",
                      "Partial",
                      "—",
                    ],
                    ["Real-time PDF editing", "✓", "—", "—", "—", "—"],
                    [
                      "High-volume generation",
                      "✓",
                      "Limited",
                      "Limited",
                      "Limited",
                      "—",
                    ],
                    ["CRM integrations", "✓", "✓", "✓", "✓", "✓"],
                    ["Enterprise security", "✓", "✓", "✓", "✓", "✓"],
                    ["Aadhaar eSign support", "✓", "—", "—", "—", "—"],
                    ["DSC digital signatures", "✓", "—", "—", "—", "—"],
                    ["Template engine", "✓", "✓", "✓", "✓", "✓"],
                    ["AI Document Insights", "✓", "—", "—", "—", "—"],
                    ["AI Template Generation", "✓", "—", "Partial", "—", "—"],
                  ].map((row, i) => (
                    <tr key={i}>
                      <td>{row[0]}</td>
                      <td
                        className="highlight-col"
                        style={{
                          color: row[1] === "✓" ? "#4f46e5" : "inherit",
                          fontWeight: row[1] === "✓" ? "bold" : "normal",
                        }}
                      >
                        {row[1]}
                      </td>
                      <td>{row[2]}</td>
                      <td>{row[3]}</td>
                      <td>{row[4]}</td>
                      <td>{row[5]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* 14. FINAL CTA */}
        <section
          className="product-section product-section-alt"
          style={{ padding: "12rem 0" }}
        >
          <div className="sec-container" style={{ textAlign: "center" }}>
            <h2 className="gen-h2">Automate Your Document Workflows Today</h2>
            <p
              className="gen-h2-sub"
              style={{ maxWidth: "60rem", margin: "0 auto 4.8rem auto" }}
            >
              Join enterprises that ship documents from their systems in
              seconds. Start with a demo or the developer sandbox.
            </p>
            <div
              className="product-cta-group"
              style={{ justifyContent: "center" }}
            >
              <a href="/contact" className="product-btn product-btn-primary">
                Book a Demo
              </a>
              {/* <a
                href="/api-catalogue-home"
                className="product-btn product-btn-outline"
                style={{ borderColor: "#e2e8f0", color: "#0f172a" }}
              >
                Developer Sandbox
              </a> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Dokgenai;
